import {FunctionalComponent, h} from "preact";
import TextEffects from "../../effects/textEffects";
import {MessageFrame} from "../../components/messageFrame";

const QuestionBox: FunctionalComponent<{ msgID: string; msgText: string; questionRawObject: any; disableEffects?: number[]; showInputBoxCallback: (questionRawObj: any) => void; tickCallback: () => void }> = ({msgID, msgText, questionRawObject, disableEffects, showInputBoxCallback, tickCallback}) => {

    function questionRenderedCallback(): void {
        showInputBoxCallback(questionRawObject);
        tickCallback();
    }

    return (<MessageFrame clsName=''>
              <p id={`m_${msgID}`}>
                <TextEffects disableEffects={disableEffects} msgText={msgText} tickCallback={questionRenderedCallback} />
            </p>
    </MessageFrame>);
};

export default QuestionBox;
